import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { BREAKPOINT, BreakpointService, CmsComponentData } from '@spartacus/storefront';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CustomOhgarTextStaticBannerData } from './custom-ohgar-text-static-banner.model';

@Component({
  selector: 'app-custom-ohgar-text-static-banner',
  templateUrl: './custom-ohgar-text-static-banner.component.html',
  styleUrls: ['./custom-ohgar-text-static-banner.component.scss'],
  standalone: false
})
export class CustomOhgarTextStaticBannerComponent implements OnInit {
  @Input() item: CustomOhgarTextStaticBannerData;
  @HostBinding('class') styleClasses: string;

  data$: Observable<CustomOhgarTextStaticBannerData> = this.component.data$.pipe(
    tap((data) => (this.styleClasses = data?.styleClasses))
  );

  constructor(
    public component: CmsComponentData<CustomOhgarTextStaticBannerData>,
    protected breakpointService: BreakpointService,
  ) { }

  isMobile(): Observable<boolean> {
    return this.breakpointService?.isDown(BREAKPOINT.md);
  }

  ngOnInit(): void {
    if (this.item) {
      this.data$ = of(this.item);
    }
  }
}
